import Axios from 'axios'

const useFetchUghubToken = () => {

    const getToken = async () => {
        try {
            const response = await Axios.get( `https://auth.cert.works.go.ug/api/getToken` )
            if( response.data ) {
                let { access_token } = response.data?.data
                return access_token
            }
        } catch (error) {
            console.error( error )
        }
    } 

    return getToken
}

export default useFetchUghubToken